import React from 'react'

const About = props => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <h2 className="page-title">About Headed2</h2>
        </div>
      </div>
      <div
        className="title-block-bar"
        style={{ paddingTop: '75px', backgroundColor: '#80BC00' }}>
        <div className="container">
          <div className={'row'}>
            <div className={'col-sm-9'}>
              <p style={{ fontSize: '1.2rem' }}>
                For <b>over 15 years</b>, Headed2 has been helping students{' '}
                <b>plan for their future</b> and <b>explore the world of work</b>. In that
                time, we have grown into a reliable and robust platform that services{' '}
                <b>millions of individuals</b> each year from across the United States.
              </p>
            </div>
            <div className="col-sm-3">
              <img src="/images/www/new/abouth2/AboutH2-HeaderImg.svg" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="row section feature-contact-section"
        style={{ paddingTop: '50px', paddingBottom: '50px' }}>
        <div
          className="title-block-bar"
          style={{
            backgroundColor: '#EEE',
            paddingTop: '60px',
            paddingBottom: '60px'
          }}>
          <div className="container">
            <h3 style={{ marginBottom: '25px' }}>What Our Customers Say</h3>
            <div className="embed-responsive embed-responsive-16by9">
              <video
                width="320"
                height="240"
                controls="true"
                poster="/images/www/poster.png"
                className="embed-responsive-item">
                <source
                  src="https://h2-training.s3.amazonaws.com/Headed2+Testimonials+2021.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container section"
        style={{ paddingTop: '25px', paddingBottom: '25px' }}>
        <h3>Our History</h3>
        <img
          src="/images/www/new/abouth2/AboutH2-KeyPoint1.svg"
          style={{ marginLeft: '20px' }}
          alt="Programmed the computerized Interest profiler and Work Importance Profiler for the USDOL"
          className="pull-right"
        />
        <p style={{ fontSize: '1rem' }}>
          Our story starts in 1998 when the United States Department of Labor (USDOL)
          first released O*NET - an electronic database of occupations. In an effort to
          make career information accessible to everybody, they encouraged people to make
          use of their data in user-friendly ways. Headed2’s co-founder, Jason Cernansky,
          working for the New York State Department of Labor (NYSDOL), saw an opportunity
          and created one of the first programs to utilize the data. Thus, New York
          CareerZone was born.
        </p>
        <br className="clear" />
        <img
          src="/images/www/new/abouth2/AboutH2-KeyPoint2.svg"
          style={{ marginLeft: '20px' }}
          alt={
            "Created the inline version of the Harrington-O'Shea CDM-R Interest Assessment"
          }
          className="pull-right"
        />
        <p style={{ fontSize: '1rem' }}>
          With a strong knowledge of O*NET and other labor market information, Jason left
          the NYSDOL and joined David Whittaker to start a company that would later become
          Headed2. They developed the CareerExplorer product, and together consulted on
          many other projects to hone their skills.
        </p>
      </div>

      <div
        className="title-block-bar"
        style={{
          backgroundColor: '#F2F7E7',
          paddingTop: '60px',
          paddingBottom: '60px'
        }}>
        <div className="container section">
          <img
            src="/images/www/new/abouth2/AboutH2-KeyPoint3.svg"
            style={{ marginLeft: '20px' }}
            alt="Only 70% of high school graduates go to college, but more than 40% will not finish"
            className="pull-right"
          />
          <h3>Our Mission</h3>
          <p style={{ color: ' #000', fontSize: '1rem' }}>
            At Headed2, we believe in the democratization of career information. For too
            long, career guidance and planning was an afterthought, and only talked about
            in the context of what to do after college. By offering world class planning
            tools, coupled with detailed information for research, and financial literacy
            tools for validating their plans, the Headed2 CareerExplorer helps to make
            sure that students have access to tools and information to help them succeed.
            At Headed, we believe that the planning they do in school is only just the
            beginning of a students' career journey... that's why we give students access
            to our planning tools for life.
          </p>
        </div>
      </div>
      <div className="container section" style={{ marginBottom: '40px' }}>
        <h3>Our Journey</h3>
        <img
          src="/images/www/new/abouth2/AboutH2-OurJourney.svg"
          className="img-responsive"
        />
      </div>
    </div>
  )
}

export default About
